/**
 * Título de sección del home, como en la referencia ("ALL DAY BREAKFAST_",
 * "WHAT'S ON YOUR MIND?_"): Faktor Condensed ExtraBold inclinada, mayúsculas,
 * casi negro, rematada con un guion verde sobre la línea base.
 *
 * Faktor solo trae la versión recta: la inclinación la sintetiza el navegador.
 * A 22px da el ancho de la referencia; su letra es un poco más alta en
 * proporción, así que se estira 5% en vertical (mayúscula ~17.8px, como allá).
 *
 * Lo usan los títulos de categoría del menú y el de la barra de categorías.
 */
export default function TituloSeccion({ children, className = '' }) {
  return (
    <h2 className={`font-faktor font-extrabold italic uppercase text-[21px] tracking-tight leading-none text-menu-category-title scale-y-105 origin-bottom-left ${className}`}>
      {children}
      <span aria-hidden="true" className="inline-block w-2 h-[5px] ml-0.5 bg-menu-category-dash" />
    </h2>
  );
}
